module.exports = __webpack_public_path__ + "img/GAME_SOUNDLINK.495cb448.png";